class InputDeviceModel {
    constructor(InputDevice) {
        const { inDevId } = InputDevice;
        this.label = inDevId;
        this.value = inDevId;
    }
}

export default InputDeviceModel;